export const PKG_NAME = '@vitus-labs/coolgrid'

/* eslint-disable import/prefer-default-export */
export const CONTEXT_KEYS = [
  // 'breakpoints',
  // 'rootSize',
  'columns',
  'size',
  'gap',
  'padding',
  'gutter',
  'colCss',
  'colComponent',
  'rowCss',
  'rowComponent',
  'contentAlignX',
]
